import * as api from 'api/endpoints/clients/clients.api';
import * as ClientsTypes from './clients.types';
import { messageError, messageSuccess, messageWarning } from 'views/components/message';
import { notificationErr } from 'views/components/notification';
import { clientsError } from 'utils/errorCodes';
import {
  IAssociationInfoState,
  IClientState,
  IClientsInitialState,
  IMatchingState,
  INewExchangeRatesItem,
  IPointOfSaleBrandWorksState,
  IPointOfSaleExchangesState,
  IPointOfSaleState,
  IPointOfSalesExchangeRate,
  ITarifClientsItem,
  IUpdateAliasPointOfSaleProps,
  IcreatePointOfSaleProps,
  TAddressaValues,
  TClientToUpdateRequest,
  TDataUpgrade,
  TPointsOfSaleToUpdateRequest,
  TSegmentationsValuesState,
  TclientDataToUpgradeItem,
} from 'interfaces/clients.interface';
import {
  ICountryAPIResponseItem,
  IGetExchangesAPIResponseItem,
} from 'api/endpoints/general/general.response.interface';
import {
  IcreateClientAliasAPIBody,
  IGetBrandSegmentationsAPIResponseItem,
  IgetExchangeRateAPIResponseItem,
  IupdateClientAPIBody,
} from 'api/endpoints/clients/clients.response.interface';
import { IAssociationsStates, ITranslate } from 'interfaces/general.interface';
import * as status from 'interfaces/general.interface';
import { TclientsDispatchReducer } from './clients.reducer';

export async function getClientsAction({
  dispatch,
  tenantId,
  associationStates,
  exchanges,
  countries,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  tenantId: string;
  associationStates: IAssociationsStates;
  exchanges: IGetExchangesAPIResponseItem[];
  countries: ICountryAPIResponseItem[];
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({ type: ClientsTypes.SET_IS_LOADING_GET_CLIENTS, payload: true });
  dispatch({ type: ClientsTypes.SET_CLIENTS, payload: [] });
  dispatch({ type: ClientsTypes.SET_POINTS_OF_SALE, payload: [] });
  try {
    const [clientsAssociationsFetch] = await Promise.all([
      api.getAssociationsAPI({ tenantId, token }),
    ]);

    if (clientsAssociationsFetch.response.status === 200) {
      const sortClientsAliases =
        clientsAssociationsFetch.data.pending_client_aliases.sort((a, b) =>
          a?.client?.name?.localeCompare(b.client.name)
        );
      const sortClientsRequests = clientsAssociationsFetch.data.pending_requests.sort(
        (a, b) => a?.client.name?.localeCompare(b.client.name)
      );
      const sortClientsMatching = clientsAssociationsFetch.data.matched_requests.sort(
        (a, b) => a?.alias.name?.localeCompare(b.alias.name)
      );
      const sortClientsConnections =
        clientsAssociationsFetch.data.connected_associations.sort((a, b) =>
          a?.client_alias?.name?.localeCompare(b.client_alias.name)
        );
      // const sortClientsDisconnectedConnections = clientsAssociationsFetch.data.diconnected_client_aliases.sort((a, b) => a?.client?.name?.localeCompare(b.client.name))
      // const sortClientsRejectedConnections = clientsAssociationsFetch.data.rejected_requests.sort((a, b) => a?.client?.name?.localeCompare(b.client.name))
      let clientsAliases: IClientState[] = [];
      let clientsRequests: IClientState[] = [];
      let clientsMatchings: IClientState[] = [];
      let clientsConnections: IClientState[] = [];
      // let clientsDisconnected: IClientState[] = []
      // let clientsRejected: IClientState[] = []
      let allPointsOfSale: IPointOfSaleState[] = [];

      for (const client of sortClientsAliases) {
        const getClient = await getClients({
          client,
          associationStates,
          countries,
          exchanges,
          statusType: '',
          token,
          translate,
        });
        clientsAliases.push(getClient);
        getClient.clientSalePoint?.forEach((pointOfSale) => {
          pointOfSale.businessName = getClient.name;
          pointOfSale.tradeName = getClient.legal_name;
          pointOfSale.clientStatus = '';
          allPointsOfSale.push(pointOfSale);
        });
      }

      for (const client of sortClientsRequests) {
        const getClient = await getClients({
          client,
          associationStates,
          countries,
          exchanges,
          statusType: status.pending,
          token,
          translate,
        });
        clientsRequests.push(getClient);
        getClient.clientSalePoint?.forEach((pointOfSale) => {
          pointOfSale.businessName = getClient.name;
          pointOfSale.tradeName = getClient.legal_name;
          pointOfSale.clientStatus = status.pending;
          allPointsOfSale.push(pointOfSale);
        });
      }

      for (const client of sortClientsMatching) {
        const getClient = await getClients({
          client: client.association,
          associationStates,
          countries,
          exchanges,
          statusType: status.matching,
          token,
          translate,
        });
        const findMatch = client.alias;
        const {
          id,
          name,
          legal_name,
          cif,
          address,
          postal_code,
          city,
          province,
          floor,
          door,
          lat,
          lng,
          email,
          web,
          tel_prefix,
          tel_sufix,
          country_id,
          contact_name,
          instagram,
          youtube,
          linkedin,
          facebook,
        } = client.alias;
        const { client_id, state_id } = client.association;
        const ownCLientObj: IMatchingState = {
          key: id,
          code: getClient.code ?? '',
          tradeName: name,
          businessName: legal_name,
          cif: cif,
          address: address,
          postal_code: postal_code,
          city: city,
          country: {
            id: country_id,
            name: countries.find((country) => country.id === country_id)?.name ?? '',
          },
          province: province,
          floor: floor ?? '',
          door: door ?? '',
          lat: lat ?? 0,
          lng: lng ?? 0,
          email: email,
          web: web ?? '',
          tel_prefix: tel_prefix,
          tel_sufix: tel_sufix,
          status: status.matching,
          instagram: instagram ?? '',
          youtube: youtube ?? '',
          linkedin: linkedin ?? '',
          facebook: facebook ?? '',
          // totalPointsSale: 2,
          // segmentations: "",
          // tiers: "",
          contact_name: contact_name ?? '',
          client_id: client_id ?? '',
          state_id,
          country_id,
        };
        findMatch && (getClient.matching = ownCLientObj);
        clientsMatchings.push(getClient);
        for (const pointOfSale of getClient.clientSalePoint) {
          pointOfSale.businessName = getClient.name;
          pointOfSale.tradeName = getClient.legal_name;
          pointOfSale.clientStatus = status.matching;
          allPointsOfSale.push(pointOfSale);
        }
      }

      for (const client of sortClientsConnections) {
        let clientBrandsSold: IPointOfSaleBrandWorksState[] = [];
        const getClient = await getClients({
          client,
          associationStates,
          countries,
          exchanges,
          statusType: status.connected,
          token,
          translate,
        });
        clientsConnections.push(getClient);
        for (const pointOfSale of getClient.clientSalePoint) {
          pointOfSale.businessName = getClient.name;
          pointOfSale.tradeName = getClient.legal_name;
          pointOfSale.clientStatus = status.connected;
          allPointsOfSale.push(pointOfSale);
          for (const item of pointOfSale.point_of_sale_brand_works) {
            const findBrand = clientBrandsSold.findIndex((brand) => brand.id === item.id);
            if (findBrand === -1) {
              clientBrandsSold.push(item);
            }
          }
          getClient.clientBrandsSold = clientBrandsSold;
        }
      }

      // for (const client of sortClientsDisconnectedConnections as IClientState[]) {
      // 	const getClient = await getClients(client, associations, status.disconnected, categories, token)
      // 	clientsDisconnected.push(getClient)
      // 	// getClient.clientSalePoint?.forEach((pointOfSale: IPointOfSaleState) => {
      // 	// 	pointOfSale.businessName = getClient.businessName
      // 	// 	pointOfSale.tradeName = getClient.tradeName
      // 	// 	pointOfSale.clientStatus = status.disconnected
      // 	// 	// allPointsOfSale.push(pointOfSale)
      // 	// })
      // }

      // for (const client of sortClientsRejectedConnections as IClientState[]) {
      // 	const getClient = await getClients(client, associations, status.rejected, categories, token)
      // 	clientsRejected.push(getClient)
      // 	// getClient.clientSalePoint?.forEach((pointOfSale: IPointOfSaleState) => {
      // 	// 	pointOfSale.businessName = getClient.businessName
      // 	// 	pointOfSale.tradeName = getClient.tradeName
      // 	// 	pointOfSale.clientStatus = status.rejected
      // 	// 	// allPointsOfSale.push(pointOfSale)
      // 	// })
      // }

      const sortAllPointsOfSale = allPointsOfSale.sort((a, b) =>
        a.state_name?.localeCompare(b.state_name)
      );
      dispatch({
        type: ClientsTypes.SET_POINTS_OF_SALE,
        payload: sortAllPointsOfSale,
      });
      const clients = [
        ...clientsRequests,
        ...clientsMatchings,
        ...clientsConnections,
        ...clientsAliases,
      ];
      // const clients = [...clientsRequests, ...clientsMatchings, ...clientsConnections, ...clientsAliases, ...clientsDisconnected, ...clientsRejected]
      dispatch({
        type: ClientsTypes.SET_CLIENTS,
        payload: clients,
      });
      return true;
    }
    if (clientsAssociationsFetch.response.status !== 404) {
      notificationErr(clientsError.getClients_002, translate);
    }
    return false;
  } catch (err) {
    console.log(err);
    notificationErr(clientsError.getClients_001, translate);
    return false;
  } finally {
    dispatch({ type: ClientsTypes.REFRESH_CLIENTS, payload: false });
    dispatch({ type: ClientsTypes.SET_IS_LOADING_GET_CLIENTS, payload: false });
  }
}

export async function selectClientAction({
  dispatch,
  client,
  translate,
  token,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  client: IClientState;
  translate: ITranslate;
  token: string;
}): Promise<boolean> {
  dispatch({ type: ClientsTypes.IS_LOADING_SELECT_CLIENT, payload: true });
  try {
    if (client.associationInfo?.client_alias_id) {
      const [getPointsOfSaleAssociationsFecth, getClientContactsFecth] =
        await Promise.all([
          api.getPointsOfSaleAssociationsAPI({
            clientAliasId: client.associationInfo?.client_alias_id,
            token,
          }),
          api.getClientContactsAPI({
            clientId: client.associationInfo?.client_id,
            token,
          }),
        ]);
      if (getClientContactsFecth.response.status === 200) {
        const mapClientContacts = getClientContactsFecth.data.company_client_contacts.map(
          (contact) => {
            const {
              id,
              name,
              surname,
              email,
              telephone_prefix,
              telephone_sufix,
              sector,
            } = contact.contact;
            return {
              id,
              name,
              surname,
              email,
              telephone_prefix,
              telephone_sufix,
              sector,
            };
          }
        );
        client.contacts = mapClientContacts;
      }
      if (getClientContactsFecth.response.status === 404) {
        client.contacts = [];
      }
      if (getPointsOfSaleAssociationsFecth.response.status === 200) {
        const {
          client_points_of_sale,
          connected_points_of_sale,
          matched_points_of_sale,
        } = getPointsOfSaleAssociationsFecth.data;
        client.pendingPointsOfSaleAssociations =
          client_points_of_sale.length +
          matched_points_of_sale.length -
          connected_points_of_sale.length;
      }
    }
    dispatch({
      type: ClientsTypes.SELECT_CLIENT,
      payload: client,
    });
    return true;
  } catch (error) {
    notificationErr(clientsError.selectClient_001, translate);
    return false;
  } finally {
    dispatch({ type: ClientsTypes.IS_LOADING_SELECT_CLIENT, payload: false });
  }
}

export function selectPointOfSaleAction({
  dispatch,
  pointOfSale,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  pointOfSale: IPointOfSaleState | null;
}) {
  return dispatch({
    type: ClientsTypes.SELECT_POINT_OF_SALE,
    payload: pointOfSale,
  });
}

export async function createClientAction({
  dispatch,
  client,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  client: IcreateClientAliasAPIBody;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  try {
    const createClientFetch = await api.createClientAliasAPI({ client, token });
    if (createClientFetch.response.status === 403) {
      messageWarning(translate('clients_actions_client-exists'));
      return false;
    }
    if (createClientFetch.response.status === 200) {
      const {
        id,
        code,
        name,
        legal_name,
        cif,
        address,
        floor,
        door,
        lat,
        lng,
        postal_code,
        city,
        province,
        region,
        email,
        web,
        tel_prefix,
        tel_sufix,
        contact_name,
        instagram,
        youtube,
        facebook,
        linkedin,
        createdAt,
        updatedAt,
      } = createClientFetch.data;
      const newClient: IClientState = {
        key: id,
        code,
        name,
        legal_name,
        cif: cif,
        address: address,
        floor: floor,
        door: door,
        lat: lat,
        lng: lng,
        postal_code: postal_code,
        city: city,
        country_id: region,
        province: province,
        email: email,
        web: web,
        createdAt,
        updatedAt,
        tel_prefix: tel_prefix,
        tel_sufix: tel_sufix,
        contact_name,
        totalPointsSale: 0,
        segmentations: '',
        tiers: '',
        clientSalePoint: [],
        status: '',
        pendingPointsOfSaleAssociations: 0,
        instagram,
        youtube,
        facebook,
        linkedin,
        associationInfo: {} as IAssociationInfoState,
        matching: null,
        contacts: [],
        enableModify: false,
        clientBrandsSold: [],
        clientStatus: '',
        clientDataToUpgrade: [] as TclientDataToUpgradeItem[],
        tarif_clients: [],
      };
      messageSuccess(translate('clients_actions_add-client-success'));
      dispatch({
        type: ClientsTypes.CREATE_CLIENT,
        payload: newClient,
      });
      return true;
    } else {
      notificationErr(clientsError.createClient_002, translate);
      return false;
    }
  } catch (err) {
    notificationErr(clientsError.createClient_001, translate);
    return false;
  }
}

export async function updateClientAction({
  dispatch,
  clientId,
  client,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clientId: string;
  client: Partial<IupdateClientAPIBody>;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({ type: ClientsTypes.SET_IS_LOADING_UPDATE_CLIENT, payload: true });
  try {
    const updateClientFetch = await api.updateClientAPI({ clientId, client, token });
    if (
      updateClientFetch.response.status === 202 ||
      updateClientFetch.response.status === 200
    ) {
      dispatch({
        type: ClientsTypes.UPDATE_CLIENT,
        payload: { client, clientId },
      });
      messageSuccess(translate('clients_actions_update-client-success'));
      return true;
    } else {
      messageSuccess(translate('clients_actions_update-client-error'));
      notificationErr(clientsError.updateClient_001, translate);
      return false;
    }
  } catch (err) {
    notificationErr(clientsError.updateClient_002, translate);
    return false;
  } finally {
    dispatch({ type: ClientsTypes.SET_IS_LOADING_UPDATE_CLIENT, payload: false });
  }
}

export async function deleteClientAction({
  dispatch,
  clients,
  clientAliasId,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clients: IClientState[];
  clientAliasId: string;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  const findClient = clients.find((client) => client.key === clientAliasId);
  if (!findClient) {
    messageError('No se ha encontrado el cliente');
    return false;
  }
  if (findClient.status !== '') {
    messageWarning('No se puede eliminar un cliente que no es propio');
    return false;
  }
  try {
    const deleteClientFetch = await api.deleteClientAliasAPI({ clientAliasId, token });
    if (
      deleteClientFetch.response.status === 200 &&
      deleteClientFetch.data[0].deleted === 1
    ) {
      messageSuccess('Cliente eliminado correctamente');
      dispatch({
        type: ClientsTypes.DELETE_CLIENT,
        payload: clientAliasId,
      });
      return true;
    } else {
      messageError('Error al eliminar el cliente');
      notificationErr(clientsError.deleteClient_002, translate);
      return false;
    }
  } catch (err) {
    notificationErr(clientsError.deleteClient_001, translate);
    return false;
  }
}

export async function createPointOfSaleAction({
  dispatch,
  clientSelected,
  segmentationsState,
  pointOfSale,
  countries,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clientSelected: IClientState;
  segmentationsState: IGetBrandSegmentationsAPIResponseItem;
  pointOfSale: IcreatePointOfSaleProps;
  countries: ICountryAPIResponseItem[];
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({ type: ClientsTypes.REFRESH_CLIENTS, payload: true });
  const {
    brand_id,
    tenant_id,
    code,
    province,
    city,
    postal_code,
    address,
    floor,
    door,
    lat,
    lng,
    online,
    tel_prefix,
    tel_sufix,
    web,
    country_id,
    division_id,
    segmentation_id,
    tier_id,
    exchange_id,
    own_store,
  } = pointOfSale;
  delete pointOfSale.category_id_online;
  delete pointOfSale.category_id_physical;
  const { key: client_alias_id, name, legal_name, clientSalePoint } = clientSelected;
  const body = {
    brand_id: brand_id,
    tenant_id: tenant_id,
    point_of_sale: {
      client_alias_id,
      ...pointOfSale,
    },
    division_id: division_id,
    segmentation_id: segmentation_id,
    tier_id: tier_id,
    categories: pointOfSale.categories,
  };
  try {
    const createPointOfSaleFetch = await api.createPointOfSaleAPI(body, token);
    if (createPointOfSaleFetch.response.status === 403) {
      return messageWarning('Ya existe un punto de venta con el mismo nombre');
    }
    if (
      createPointOfSaleFetch.response.status === 202 ||
      createPointOfSaleFetch.response.status === 200
    ) {
      const { division, segmentations, tiers } = createPointOfSaleFetch.data;
      let newDivisions: TSegmentationsValuesState[] = [];
      let newSegmentations: TSegmentationsValuesState[] = [];
      let newTiers: TSegmentationsValuesState[] = [];
      for (const dv of division) {
        const findDivision = segmentationsState.division.find(
          (item) => item.id === dv.division_id
        );
        if (findDivision) {
          newDivisions.push({ value: findDivision.id, label: findDivision.name });
        }
      }
      for (const segmentation of segmentations) {
        const findSegmentation = segmentationsState.segmentation.find(
          (item) => item.id === segmentation.segmentation_id
        );
        if (findSegmentation) {
          newSegmentations.push({
            value: findSegmentation.id,
            label: findSegmentation.name,
          });
        }
      }
      for (const tier of tiers) {
        const findTier = segmentationsState.tier.find((item) => item.id === tier.tier_id);
        if (findTier) {
          newTiers.push({ value: findTier.id, label: findTier.name });
        }
      }
      const { id, name: namePS } = createPointOfSaleFetch.data.point_of_sale;
      const newPointOfSaleObj: IPointOfSaleState = {
        index: clientSalePoint.length,
        key: id,
        code,
        name: namePS,
        tradeName: name,
        businessName: legal_name,
        client_alias_id,
        point_of_sale_id: '',
        area: Number(pointOfSale.area),
        country: {
          id: country_id,
          name: countries.find((country) => country.id === country_id)?.name as string,
        },
        categories: pointOfSale.categories,
        state_id: null,
        state_name: 'pending',
        province,
        city,
        postal_code,
        address,
        door,
        floor,
        lat,
        lng,
        tel_prefix,
        tel_sufix,
        start_season: null,
        start_date: null,
        web,
        email: null,
        full_price: null,
        online,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        connected: false,
        receiving: false,
        data_share: false,
        contact_name: null,
        point_of_sale_brand_works: [],
        clientStatus: '',
        exchange_id: exchange_id,
        division_id: newDivisions,
        segmentation_id: newSegmentations,
        tier_id: newTiers,
        last_sale: null,
        point_of_sale_exchange_rates: [],
        hss: 0,
        own_store: own_store,
      };
      dispatch({
        type: ClientsTypes.CREATE_POINT_OF_SALE,
        payload: newPointOfSaleObj,
      });
      messageSuccess(translate('clients_actions_add-point-of-sale-success'));
      return true;
    } else {
      messageError(translate('clients_actions_add-point-of-sale-error'));
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
}

export async function updatePointOfSaleAction({
  dispatch,
  tenantId,
  clientSelected,
  segmentationsState,
  pointOfSale,
  countries,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  tenantId: string;
  clientSelected: IClientState;
  segmentationsState: IGetBrandSegmentationsAPIResponseItem;
  pointOfSale: IUpdateAliasPointOfSaleProps;
  countries: ICountryAPIResponseItem[];
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: ClientsTypes.REFRESH_CLIENTS, payload: true });
  const {
    id,
    name,
    country_id,
    province,
    city,
    postal_code,
    address,
    floor,
    door,
    lat,
    lng,
    area,
    tel_prefix,
    tel_sufix,
    web,
    code,
    online,
    categories,
  } = pointOfSale;
  const { clientSalePoint } = clientSelected;
  const divisions = !pointOfSale.division_id
    ? null
    : pointOfSale.division_id[0]?.value
      ? pointOfSale.division_id.map((item) => item.value)
      : pointOfSale.division_id;
  const segmentations = !pointOfSale.segmentation_id
    ? null
    : pointOfSale.segmentation_id[0]?.value
      ? pointOfSale.segmentation_id.map((item) => item.value)
      : pointOfSale.segmentation_id;
  const tiers = !pointOfSale.tier_id
    ? null
    : pointOfSale.tier_id[0]?.value
      ? pointOfSale.tier_id.map((item) => item.value)
      : pointOfSale.tier_id;
  const body: any = {
    tenant_id: tenantId,
    point_of_sale_id: id,
    update: pointOfSale,
    segmentation_id: segmentations,
    division_id: divisions,
    tier_id: tiers,
  };
  delete body.update.division_id;
  delete body.update.segmentation_id;
  delete body.update.tier_id;
  if (online) {
    delete body.update.door;
    delete body.update.floor;
    delete body.update.lat;
    delete body.update.lng;
    delete body.update.area;
    delete body.update.address;
    delete body.update.city;
    delete body.update.province;
    delete body.update.postal_code;
  }
  let newDivisions: TSegmentationsValuesState[] = [];
  let newSegmetations: TSegmentationsValuesState[] = [];
  let newTiers: TSegmentationsValuesState[] = [];
  (divisions as string[]).forEach((division) => {
    const findDivision = segmentationsState.division.find((item) => item.id === division);
    if (findDivision) {
      newDivisions.push({ value: findDivision.id, label: findDivision.name });
    }
  });
  (segmentations as string[]).forEach((segmentation) => {
    const findSegmentation = segmentationsState.segmentation.find(
      (item) => item.id === segmentation
    );
    if (findSegmentation) {
      newSegmetations.push({ value: findSegmentation.id, label: findSegmentation.name });
    }
  });
  (tiers as string[]).forEach((tier) => {
    const findTier = segmentationsState.tier.find((item) => item.id === tier);
    if (findTier) {
      newTiers.push({ value: findTier.id, label: findTier.name });
    }
  });
  try {
    const updatePointOfSaleFetch = await api.updatePointOfSaleAPI(body, token);
    if (updatePointOfSaleFetch.response.status === 200) {
      const assignCategories = await api.assignCategoriesAPI({
        pointOfSaleId: id,
        categories: categories,
        token,
      });

      const findPointOfSale = clientSalePoint.find(
        (pointOfSale) => pointOfSale.key === id
      );
      if (findPointOfSale) {
        findPointOfSale.name = name;
        findPointOfSale.country = {
          id: country_id as string,
          name: countries.find((country) => country.id === country_id)?.name as string,
        };
        findPointOfSale.province = province as string;
        findPointOfSale.city = city as string;
        findPointOfSale.postal_code = postal_code as string;
        findPointOfSale.address = address as string;
        findPointOfSale.floor = floor as string;
        findPointOfSale.door = door as string;
        findPointOfSale.lat = lat as number;
        findPointOfSale.lng = lng as number;
        findPointOfSale.area = area as number;
        findPointOfSale.tel_prefix = tel_prefix;
        findPointOfSale.tel_sufix = tel_sufix;
        findPointOfSale.web = web as string;
        findPointOfSale.code = code as string;
        findPointOfSale.online = online;
        findPointOfSale.division_id = newDivisions;
        findPointOfSale.segmentation_id = newSegmetations;
        findPointOfSale.tier_id = newTiers;
      }
      if (
        findPointOfSale &&
        (assignCategories.response.status === 200 ||
          assignCategories.response.status === 201)
      ) {
        findPointOfSale.categories = categories;
      } else {
        messageError(
          translate('action_points-of-sale_assign-point-of-sale-categories_error')
        );
      }
      dispatch({
        type: ClientsTypes.UPDATE_POINT_OF_SALE,
        payload: clientSelected,
      });
      messageSuccess(translate('clients_actions_update-point-of-sale-success'));
      return true;
    } else {
      messageError(translate('clients_actions_update-point-of-sale-error'));
      return false;
    }
  } catch (err) {
    console.log(err);
    messageError(translate('clients_actions_update-point-of-sale-error'));
    return false;
  }
}

export async function removePointOfSaleAction({
  dispatch,
  pointOfSale,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  pointOfSale: IPointOfSaleState;
  token: string;
  translate: ITranslate;
}) {
  try {
    const removePointOfSaleFetch = await api.removePointOfSaleAPI(pointOfSale.key, token);
    if (removePointOfSaleFetch.response.status === 200) {
      dispatch({
        type: ClientsTypes.REMOVE_POINT_OF_SALE,
        payload: pointOfSale.key,
      });
      messageSuccess(translate('clients_actions_remove-point-of-sale-success'));
      return true;
    } else {
      messageError(translate('clients_actions_remove-point-of-sale-error'));
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
}

interface FieldToUpgrade {
  pointOfSaleId: string;
}
export async function upgradePointsOfSaleAction({
  dispatch,
  tenantId,
  countries,
  clientSelected,
  clientsState,
  pointsOfSaleState,
  fieldsToUpgrade,
  clientId,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  tenantId: string;
  countries: ICountryAPIResponseItem[];
  clientSelected: IClientState;
  clientsState: IClientState[];
  pointsOfSaleState: IPointOfSaleState[];
  fieldsToUpgrade: TDataUpgrade[];
  clientId: string;
  token: string;
  translate: ITranslate;
}) {
  const separatedByPointOfSaleId = fieldsToUpgrade.reduce(
    (acc: Record<string, FieldToUpgrade[]>, item) => {
      if (!acc[item.pointOfSaleId]) {
        acc[item.pointOfSaleId] = [];
      }
      acc[item.pointOfSaleId].push(item);
      return acc;
    },
    {}
  );

  const pointsOfSaleToUpgrade = Object.entries(separatedByPointOfSaleId).map(
    ([pointOfSaleId, fields]) => ({
      pointOfSaleId,
      fields: fields as TDataUpgrade[],
    })
  );

  // Map each point of sale
  let updatedPointsOfSale = 0;
  let copyOfClientSelected: IClientState = JSON.parse(JSON.stringify(clientSelected));
  let copyOfClients: IClientState[] = JSON.parse(JSON.stringify(clientsState));
  let copyOfPointsOfSale: IPointOfSaleState[] = JSON.parse(
    JSON.stringify(pointsOfSaleState)
  );

  for (const item of pointsOfSaleToUpgrade) {
    type TBodyFFields = {
      online?: boolean;
      categories?: Array<string>;
      name?: string;
      exchange_id?: string;
      area?: number;
      address?: string;
      floor?: string;
      door?: string;
      city?: string;
      province?: string;
      postal_code?: string;
      country_id?: string;
      lat?: number;
      lng?: number;
      tel_prefix?: string;
      tel_sufix?: string;
      web?: string;
    };
    let fieldsToUpdate: TBodyFFields = {};
    item.fields.forEach((field) => {
      fieldsToUpdate = {
        ...fieldsToUpdate,
        ...field.values,
      };
    });
    const body: any = {
      tenant_id: tenantId,
      point_of_sale_id: item.pointOfSaleId,
      update: fieldsToUpdate,
      segmentation_id: clientSelected.clientSalePoint
        .find((pointOfSale) => pointOfSale.key === item.pointOfSaleId)
        ?.segmentation_id.map((item) => item.value),
      division_id: clientSelected.clientSalePoint
        .find((pointOfSale) => pointOfSale.key === item.pointOfSaleId)
        ?.division_id.map((item) => item.value),
      tier_id: clientSelected.clientSalePoint
        .find((pointOfSale) => pointOfSale.key === item.pointOfSaleId)
        ?.tier_id.map((item) => item.value),
    };

    try {
      const updatePointOfSaleFetch = await api.updatePointOfSaleAPI(body, token);
      if (updatePointOfSaleFetch.response.status === 200) {
        const findCLientSalePoint = clientSelected.clientSalePoint.find(
          (pointOfSale) => pointOfSale.key === item.pointOfSaleId
        );
        let newPS: IPointOfSaleState = {
          ...(findCLientSalePoint as IPointOfSaleState),
          ...fieldsToUpdate,
        };
        if (fieldsToUpdate.categories) {
          newPS.categories = fieldsToUpdate.categories;
        }
        if (fieldsToUpdate.country_id) {
          newPS.country = {
            id: fieldsToUpdate.country_id,
            name: countries.find((country) => country.id === fieldsToUpdate.country_id)
              ?.name as string,
          };
        }
        item.fields.forEach((field) => {
          newPS.fieldsToUpdate = (newPS.fieldsToUpdate as TDataUpgrade[]).filter(
            (item) => item.field !== field.field
          );
        });

        const findClientSelectedIndex = clientSelected.clientSalePoint.findIndex(
          (pointOfSale) => pointOfSale.key === item.pointOfSaleId
        );
        copyOfClientSelected.clientSalePoint[findClientSelectedIndex] = newPS;

        const findClientIndex = clientsState.findIndex(
          (client) => client.key === clientId
        );
        const findPointOfSaleIndex = clientsState[
          findClientIndex
        ].clientSalePoint.findIndex(
          (pointOfSale) => pointOfSale.key === item.pointOfSaleId
        );
        copyOfClients[findClientIndex].clientSalePoint[findPointOfSaleIndex] = newPS;

        const findOnAllPointsOfSale = pointsOfSaleState.findIndex(
          (pointOfSale) => pointOfSale.key === item.pointOfSaleId
        );
        copyOfPointsOfSale[findOnAllPointsOfSale] = newPS;

        let haveChanges = false;
        const fieldsMap = Object.entries(fieldsToUpdate).map(([key, value]) => ({
          key,
          value,
        }));
        for (const field of fieldsMap) {
          if (field.key !== 'lat' && field.key !== 'lng') {
            haveChanges = true;
          }
        }
        haveChanges && updatedPointsOfSale++;
      } else {
        messageError(translate('clients_actions_update-point-of-sale-error'));
      }
    } catch (error) {
      console.log(error);
    }
  }

  if (updatedPointsOfSale > 0) {
    dispatch({
      type: ClientsTypes.SELECT_CLIENT,
      payload: copyOfClientSelected,
    });
    dispatch({
      type: ClientsTypes.SET_CLIENTS,
      payload: copyOfClients,
    });
    dispatch({
      type: ClientsTypes.SET_POINTS_OF_SALE,
      payload: copyOfPointsOfSale,
    });
  }
  if (updatedPointsOfSale === pointsOfSaleToUpgrade.length) {
    return messageSuccess(
      `${updatedPointsOfSale} ${
        updatedPointsOfSale === 1
          ? translate('clients_actions_upgrade-point-of-sale-success')
          : translate('clients_actions_upgrade-points-of-sale-success')
      }`
    );
  }
}

export async function shareDataPointOfSaleAction({
  dispatch,
  clientSelected,
  pointOfSaleId,
  haveToShare,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clientSelected: IClientState;
  pointOfSaleId: string;
  haveToShare: boolean;
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: ClientsTypes.REFRESH_CLIENTS, payload: true });
  const body = {
    filter: { id: pointOfSaleId },
    update: {
      data_share: haveToShare,
    },
  };
  try {
    const updatePointOfSaleFetch = await api.updatePointOfSaleAPI(body, token);
    if (updatePointOfSaleFetch.response.status === 200) {
      const findPointOfSale = clientSelected.clientSalePoint.find(
        (pointOfSale) => pointOfSale.key === pointOfSaleId
      );
      if (findPointOfSale) {
        findPointOfSale.data_share = haveToShare;
      }
      if (haveToShare) {
        messageSuccess(translate('clients_actions_share-data-point-of-sale-success'));
      } else {
        messageSuccess(
          translate('clients_actions_dont-share-data-point-of-sale-success')
        );
      }
      return dispatch({
        type: ClientsTypes.UPDATE_POINT_OF_SALE,
        payload: clientSelected,
      });
    } else {
      messageError(translate('clients_actions_update-point-of-sale-error'));
    }
  } catch (err) {
    console.log('client.actions 627', err);
  }
}

export function searchClientsAction({
  dispatch,
  state,
  query,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  state: IClientsInitialState;
  query: string;
}) {
  const copyOfClients: Array<IClientState> = JSON.parse(JSON.stringify(state.clients));
  const findByTradeName = copyOfClients.filter((client) =>
    client.name?.toLowerCase().includes(query.toLowerCase())
  );
  const findByBusinessName = copyOfClients.filter((client) =>
    client.legal_name?.toLowerCase().includes(query.toLowerCase())
  );
  const findByClientCode = copyOfClients.filter((client) =>
    client.code?.toLowerCase().includes(query.toLowerCase())
  );
  const findByCity = copyOfClients.filter((client) =>
    client.city?.toLowerCase().includes(query.toLowerCase())
  );
  const concatResults = [
    ...findByTradeName,
    ...findByBusinessName,
    ...findByClientCode,
    ...findByCity,
  ];
  const result = concatResults.filter((item, index) => {
    return concatResults.indexOf(item) === index;
  });
  return dispatch({
    type: ClientsTypes.SEARCH_CLIENTS,
    payload: {
      items: query.length === 0 ? state.clients : result,
      query,
    },
  });
}

export function searchPointsOfSaleAction({
  dispatch,
  state,
  query,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  state: IClientsInitialState;
  query: string;
}) {
  const copyOfPointsOfSale: IPointOfSaleState[] = JSON.parse(
    JSON.stringify(state.pointsOfSale)
  );
  const findByTradeName = copyOfPointsOfSale.filter((pointOfSale) =>
    pointOfSale.tradeName?.toLowerCase().includes(query.toLowerCase())
  );
  const findByBusinessName = copyOfPointsOfSale.filter((pointOfSale) =>
    pointOfSale.businessName?.toLowerCase().includes(query.toLowerCase())
  );
  const findByPointOfSaleName = copyOfPointsOfSale.filter((pointOfSale) =>
    pointOfSale.name?.toLowerCase().includes(query.toLowerCase())
  );
  const findByClientCode = copyOfPointsOfSale.filter((pointOfSale) =>
    pointOfSale.code?.toLowerCase().includes(query.toLowerCase())
  );
  const findByCity = copyOfPointsOfSale.filter((pointOfSale) =>
    pointOfSale.city?.toLowerCase().includes(query.toLowerCase())
  );
  const concatResults = [
    ...findByTradeName,
    ...findByBusinessName,
    ...findByPointOfSaleName,
    ...findByClientCode,
    ...findByCity,
  ];
  const result = concatResults.filter((item, index) => {
    return concatResults.indexOf(item) === index;
  });
  return dispatch({
    type: ClientsTypes.SEARCH_POINTS_OF_SALE,
    payload: {
      items: query.length === 0 ? state.pointsOfSale : result,
      query,
    },
  });
}

export async function acceptAssociationAction({
  dispatch,
  clients,
  exchanges,
  tenantId,
  data,
  statusType,
  associationStates,
  countries,
  setIsOpenDrawer,
  setCurrentStep,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clients: IClientState[];
  exchanges: IGetExchangesAPIResponseItem[];
  tenantId: string;
  data: TClientToUpdateRequest;
  statusType: string;
  associationStates: IAssociationsStates;
  countries: ICountryAPIResponseItem[];
  setIsOpenDrawer: any;
  setCurrentStep: any;
  token: string;
  translate: ITranslate;
}) {
  // Not matching
  dispatch({ type: ClientsTypes.SET_IS_LOADING_GET_CLIENTS, payload: true });
  try {
    if (statusType !== status.matching) {
      const body = [{ request_id: data.requestId }];
      const associateFetch = await api.associateClientAPI(body, tenantId, token);
      const findClientIndex = clients.findIndex((client) => client.key === data.id);
      if (associateFetch.response.status === 200) {
        clients[findClientIndex].associationInfo.client_alias_id =
          associateFetch.data[0].alias_id;
        dispatch({
          type: ClientsTypes.SET_CLIENTS,
          payload: clients,
        });
        setCurrentStep(1);
        await getClientsAction({
          dispatch,
          tenantId,
          associationStates,
          exchanges,
          countries,
          token,
          translate,
        });
        return;
      } else {
        setIsOpenDrawer(false);
        setCurrentStep(0);
        notificationErr(clientsError.accept_association_001, translate);
        return messageError(translate('clients_actions_association-error'));
      }
    } else {
      // Matching
      if (data.dataToUpdate.includes('address')) {
        data.dataToUpdate.push('floor');
        data.dataToUpdate.push('door');
        data.dataToUpdate.push('lat');
        data.dataToUpdate.push('lng');
      }
      const body = [
        {
          request_id: data.requestId,
          alias_id: data.aliasId,
          code: data.code,
          fields: data.dataToUpdate?.length > 0 ? data.dataToUpdate : [],
        },
      ];
      const associateFetch = await api.associateClientAPI(body, tenantId, token);
      const findClientIndex = clients.findIndex((client) => client.key === data.id);
      if (associateFetch.response.status === 200) {
        clients[findClientIndex].associationInfo.client_alias_id =
          associateFetch.data[0].alias_id;
        clients[findClientIndex].pendingPointsOfSaleAssociations = clients[
          findClientIndex
        ].clientSalePoint.filter(
          (pointOfSale) => pointOfSale.state_name === status.disconnected
        ).length;
        dispatch({
          type: ClientsTypes.SET_CLIENTS,
          payload: clients,
        });
        await getClientsAction({
          dispatch,
          tenantId,
          associationStates,
          exchanges,
          countries,
          token,
          translate,
        });
        setCurrentStep(1);
        return messageSuccess(translate('clients_actions_association-success'));
      } else {
        setIsOpenDrawer(false);
        setCurrentStep(0);
        return messageError(translate('clients_actions_association-error'));
      }
    }
  } catch (error) {
    console.log(error);
    return notificationErr(clientsError.accept_association_002, translate);
  } finally {
    dispatch({ type: ClientsTypes.SET_IS_LOADING_GET_CLIENTS, payload: false });
  }
}

export async function rejectAssociationAction({
  dispatch,
  data,
  exchanges,
  tenantId,
  associationStates,
  countries,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  data: IClientState;
  exchanges: IGetExchangesAPIResponseItem[];
  tenantId: string;
  associationStates: IAssociationsStates;
  countries: ICountryAPIResponseItem[];
  token: string;
  translate: ITranslate;
}) {
  try {
    const removeFetch = await api.detachAssociationAPI(data.associationInfo.id, token);
    if (removeFetch.response.status === 200) {
      await getClientsAction({
        dispatch,
        tenantId,
        associationStates,
        exchanges,
        countries,
        token,
        translate,
      });
      return messageSuccess(translate('clients_actions_reject-association-success'));
    } else {
      messageError(translate('clients_actions_reject-association-error'));
      return notificationErr(clientsError.reject_association_001, translate);
    }
  } catch (err) {
    messageError(translate('clients_actions_reject-association-error'));
    return notificationErr(clientsError.reject_association_002, translate);
  }
}

export async function rejectPointOfSaleAction({
  dispatch,
  data,
  clientSelected,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  data: IPointOfSaleState;
  clientSelected: IClientState;
  token: string;
  translate: ITranslate;
}) {
  try {
    const removeFetch = await api.detachPointOfSaleAPI(
      data.key,
      data.client_alias_id,
      token
    );
    if (removeFetch.response.status === 200) {
      const findPointOfSale = clientSelected.clientSalePoint.findIndex(
        (item) => item.key === data.key
      );
      clientSelected.clientSalePoint[findPointOfSale].state_name = status.disconnected;
      clientSelected.pendingPointsOfSaleAssociations =
        clientSelected.pendingPointsOfSaleAssociations + 1;
      dispatch({
        type: ClientsTypes.SELECT_CLIENT,
        payload: clientSelected,
      });
      return messageSuccess(translate('clients_actions_reject-association-success'));
    } else {
      messageError(translate('clients_actions_reject-association-error'));
      return notificationErr(clientsError.reject_ps_association_001, translate);
    }
  } catch (err) {
    messageError(translate('clients_actions_reject-association-error'));
    return notificationErr(clientsError.reject_ps_association_002, translate);
  }
}

export async function associatePointsOfSaleAction({
  dispatch,
  clientSelected,
  tenantId,
  data,
  associationStates,
  countries,
  setPointsOfSaleToUpdate,
  setIsOpenDrawer,
  setCurrentStep,
  token,
  translate,
  exchanges,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  clientSelected: IClientState;
  tenantId: string;
  data: TPointsOfSaleToUpdateRequest[];
  associationStates: IAssociationsStates;
  countries: ICountryAPIResponseItem[];
  setPointsOfSaleToUpdate: any;
  setIsOpenDrawer: any;
  setCurrentStep: any;
  token: string;
  translate: ITranslate;
  exchanges: IGetExchangesAPIResponseItem[];
}) {
  data.forEach((el, index) => {
    if (!el.alias_point_of_sale_id) {
      delete data[index].alias_point_of_sale_id;
      delete data[index].associate;
      delete data[index].update;
    }
  });
  if (data.length === 0) {
    setCurrentStep && setCurrentStep(0);
    return setIsOpenDrawer(false);
  }
  try {
    const associatePointOfSaleFetch = await api.associatePointsOfSaleAPI(
      data,
      clientSelected.associationInfo?.client_alias_id,
      token
    );
    if (associatePointOfSaleFetch.response.status === 200) {
      messageSuccess(translate('clients_actions_accept-ps-association-success'));
      setPointsOfSaleToUpdate([]);
      setIsOpenDrawer(false);
      setCurrentStep && setCurrentStep(0);
      clientSelected.pendingPointsOfSaleAssociations =
        clientSelected.pendingPointsOfSaleAssociations - data.length;
      for (const association of data) {
        const findPointOfSale = clientSelected.clientSalePoint.findIndex(
          (item) => item.key === association.alias_point_of_sale_id
        );
        if (findPointOfSale === -1) return;
        // clientSelected.clientSalePoint[findPointOfSale].status = status.connected
        clientSelected.clientSalePoint[findPointOfSale].state_name = status.connected;
      }
      return dispatch({
        type: ClientsTypes.SELECT_CLIENT,
        payload: clientSelected,
      });
    }
  } catch (err) {
    messageError(translate('clients_actions_accept-ps-association-error'));
    return notificationErr(clientsError.accept_ps_association_001, translate);
  } finally {
    const getClient = await getClients({
      client: clientSelected,
      associationStates,
      countries,
      exchanges,
      statusType: status.connected,
      token,
      translate,
    });
    clientSelected.clientSalePoint = getClient.clientSalePoint;
    clientSelected.totalPointsSale = getClient.clientSalePoint.length;
    dispatch({
      type: ClientsTypes.SELECT_CLIENT,
      payload: clientSelected,
    });
    await getClientsAction({
      dispatch,
      tenantId,
      associationStates,
      exchanges,
      countries,
      token,
      translate,
    });
  }
}

export async function getSegmentationsAction({
  dispatch,
  brandId,
  translate,
  token,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  brandId: string;
  translate: ITranslate;
  token: string;
}) {
  try {
    const segmentationsFetch = await api.getBrandSegmentationsAPI(brandId, token);
    if (segmentationsFetch.response.status === 200) {
      return dispatch({
        type: ClientsTypes.SET_SEGMENTATIONS,
        payload: segmentationsFetch.data,
      });
    } else {
      messageError('Error al obtener las segmentaciones.');
      return notificationErr(clientsError.get_segmentations_002, translate);
    }
  } catch (err) {
    messageError('Error al obtener las segmentaciones.');
    return notificationErr(clientsError.get_segmentations_001, translate);
  }
}

export async function addNewExchangeRateAction({
  dispatch,
  pointOfSaleId,
  newExchangeRates,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  pointOfSaleId: string;
  newExchangeRates: Array<INewExchangeRatesItem>;
  token: string;
  translate: ITranslate;
}) {
  const body = newExchangeRates.map((item) => {
    return {
      client_alias_point_of_sale_id: pointOfSaleId,
      start: item.start,
      end: item.end,
      rate: parseFloat(item.rate.toString()),
    };
  });
  try {
    const addNewRate = await api.addNewExchangeRateAPI({
      newRate: body,
      token,
    });
    if (addNewRate.response.status === 403) {
      messageError(translate('clients_actions_update-exchange-rate-error-403'), 15);
      return false;
    }
    if (addNewRate.response.status === 404) {
      messageError(translate('clients_actions_update-exchange-rate-error-404'), 8);
      return false;
    }
    if (addNewRate.response.status === 200) {
      const exchangeRate: IPointOfSalesExchangeRate = {
        id: addNewRate.data[0].new_item.id,
        start: addNewRate.data[0].new_item.start,
        end: addNewRate.data[0].new_item.end,
        rate: addNewRate.data[0].new_item.rate,
        createdAt: addNewRate.data[0].new_item.createdAt,
        updatedAt: addNewRate.data[0].new_item.updatedAt,
        pos_exchange_histories: [],
      };
      dispatch({
        type: ClientsTypes.ADD_NEW_EXCHANGE_RATE,
        payload: {
          exchangeRate,
          pointOfSaleId,
        },
      });
      return true;
    }
    notificationErr(clientsError.add_exchange_rate_002, translate);
    return false;
  } catch (error) {
    console.log(error);
    notificationErr(clientsError.add_exchange_rate_001, translate);
    return false;
  }
}

export async function updateExchangeRateAction({
  dispatch,
  token,
  exchangeRate,
  translate,
}: {
  dispatch: React.Dispatch<TclientsDispatchReducer>;
  token: string;
  exchangeRate: IPointOfSalesExchangeRate;
  translate: ITranslate;
}) {
  try {
    const updateExchangeRateFetch = await api.updateExchangeRateAPI({
      exchangeRateId: exchangeRate.id,
      updateBody: {
        end: exchangeRate.end,
        rate: exchangeRate.rate,
      },
      token,
    });
    if (updateExchangeRateFetch.response.status === 200) {
      messageSuccess(translate('clients_actions_update-exchange-rate-success'));
      const exchangeRate =
        updateExchangeRateFetch.data[0].point_of_sale_exchange_rates.sort((a, b) =>
          a.createdAt.localeCompare(b.createdAt)
        );
      dispatch({
        type: ClientsTypes.UPDATE_EXCHANGE_RATE,
        payload: exchangeRate,
      });
      return true;
    }
    messageError(translate('clients_actions_update-exchange-rate-error'));
    notificationErr(clientsError.update_exchange_rate_001, translate);
    return false;
  } catch (error) {
    console.log(error);
    messageError(translate('clients_actions_update-exchange-rate-error'));
    notificationErr(clientsError.update_exchange_rate_002, translate);
    return false;
  }
}

//////////////////////////////////////////////////////
//////////////////////////////////////////////////////

export type TUpgradeFields =
  | 'online'
  | 'category_id'
  | 'name'
  | 'exchange_id'
  | 'area'
  | 'address'
  | 'floor'
  | 'door'
  | 'city'
  | 'province'
  | 'postal_code'
  | 'country_id'
  | 'lat'
  | 'lng'
  | 'tel_prefix'
  | 'tel_sufix'
  | 'web';

async function getClients({
  client,
  associationStates,
  countries,
  exchanges,
  statusType,
  token,
  translate,
}: {
  client: any;
  associationStates: IAssociationsStates;
  countries: ICountryAPIResponseItem[];
  exchanges: IGetExchangesAPIResponseItem[];
  statusType: 'pending' | 'connected' | 'disconnected' | 'matching' | 'rejected' | '';
  token: string;
  translate: ITranslate;
}): Promise<IClientState> {
  const {
    id: clientId,
    brand_id,
    brand_ok,
    client_ok,
    client_alias_id,
    client_id,
    state_id,
    createdAt,
    updatedAt,
  } = client;
  const {
    id,
    code,
    name,
    legal_name,
    cif,
    address,
    postal_code,
    city,
    province,
    country_id: clientCountryId,
    floor,
    door,
    lat,
    lng,
    contact_name,
    email,
    web,
    tel_prefix,
    tel_sufix,
    instagram,
    youtube,
    facebook,
    linkedin,
  } = client.client_alias ?? client.client ?? client;

  let pointsOfSale: IPointOfSaleState[] = [];
  let tiers: any[] = [];
  let segmentations: any[] = [];
  // Connected || disconnected || ''
  if (
    statusType === status.connected ||
    statusType === status.disconnected ||
    statusType === ''
  ) {
    const getBrandPointsOfSaleFecth = await api.getBrandPointsOfSaleAPI(
      id ?? client.key,
      token
    );

    if (getBrandPointsOfSaleFecth.response.status === 200) {
      const sortPointsOfSale =
        getBrandPointsOfSaleFecth?.data?.client_alias_points_of_sale?.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      const sortPointsOfSaleIdx = sortPointsOfSale?.map((item) => item.id);
      let pointOfSaleExchangeRates: Array<IgetExchangeRateAPIResponseItem> = [];
      try {
        const getExchangeRate = await api.getExchangeRateAPI({
          clientAliasPointOfSaleIds: sortPointsOfSaleIdx,
          token,
        });
        if (getExchangeRate.response.status === 200) {
          const sortedPointOfSaleExchangeRates = getExchangeRate.data.map((item) => {
            return {
              ...item,
              point_of_sale_exchange_rates: item.point_of_sale_exchange_rates.sort(
                (a, b) => a.createdAt.localeCompare(b.createdAt)
              ),
            };
          });

          pointOfSaleExchangeRates = sortedPointOfSaleExchangeRates;
        }
      } catch (error) {
        console.log(error);
      }
      if (sortPointsOfSale) {
        for (const [index, pointOfSale] of sortPointsOfSale
          .sort((a, b) => a.name.localeCompare(b.name))
          .entries()) {
          const pointOfSaleObj: IPointOfSaleState = {
            index: index,
            key: pointOfSale.id,
            code: pointOfSale.code as string,
            name: pointOfSale.name,
            businessName: '',
            tradeName: '',
            client_alias_id: pointOfSale.client_alias_id,
            point_of_sale_id: '',
            area: pointOfSale.area ?? (0 as number),
            country: {
              id: pointOfSale.country_id,
              name: countries.find((country) => country.id === pointOfSale.country_id)
                ?.name as string,
            },
            categories: pointOfSale.client_alias_point_of_sale_categories.map(
              (item) => item.point_of_sale_category.id
            ),
            state_id: pointOfSale.state_id,
            state_name: getStateName({
              stateId: pointOfSale.state_id,
              associationStates,
            }) as string,
            province: pointOfSale.province,
            city: pointOfSale.city,
            postal_code: pointOfSale.postal_code,
            address: pointOfSale.address,
            door: pointOfSale.door as string,
            floor: pointOfSale.floor as string,
            lat: pointOfSale.lat,
            lng: pointOfSale.lng,
            tel_prefix: pointOfSale.tel_prefix,
            tel_sufix: pointOfSale.tel_sufix,
            start_season: pointOfSale.start_season as string,
            start_date: pointOfSale.start_date as string,
            web: pointOfSale.web,
            email: pointOfSale.email as string,
            full_price: pointOfSale.full_price,
            online: pointOfSale.online,
            point_of_sale_brand_works:
              pointOfSale.point_of_sale?.point_of_sale_brand_works.map((ps) => ({
                id: ps.brand.id,
                name: ps.brand.name,
                logo: ps.brand.logo,
              })) ?? [],
            connected: pointOfSale.connected ?? false,
            receiving: pointOfSale.receiving ?? false,
            data_share:
              pointOfSale.point_of_sale?.point_of_sale_datashares[0]?.data_share ?? false,
            contact_name: pointOfSale.point_of_sale?.contact_name ?? '',
            clientStatus: '',
            exchange_id:
              pointOfSale.point_of_sale?.exchange_id ?? pointOfSale?.exchange_id,
            division_id: pointOfSale.client_alias_point_of_sale_divisions.map((item) => ({
              value: item.id,
              label: item.division.name,
            })),
            segmentation_id: pointOfSale.client_alias_point_of_sale_segmentations.map(
              (item) => ({ value: item.id, label: item.segmentation.name })
            ),
            tier_id:
              pointOfSale.client_alias_point_of_sale_tiers.length > 0
                ? pointOfSale.client_alias_point_of_sale_tiers.map((item) => ({
                    value: item.id,
                    label: item.tier?.name,
                  }))
                : [],
            createdAt: pointOfSale.createdAt,
            updatedAt: pointOfSale.updatedAt,
            last_sale: pointOfSale.last_sale,
            point_of_sale_exchange_rates:
              pointOfSaleExchangeRates.find(
                (exchangeRate) => exchangeRate.id === pointOfSale.id,
                []
              )?.point_of_sale_exchange_rates ?? [],
            hss: pointOfSale.point_of_sale?.hss,
            own_store: pointOfSale.own_store,
          };
          if (pointOfSale.point_of_sale?.point_of_sale_brand_works.length > 0) {
            pointOfSaleObj.point_of_sale_brand_works =
              pointOfSale.point_of_sale?.point_of_sale_brand_works.map((item) => {
                return {
                  id: item.brand.id,
                  name: item.brand.name,
                  logo: item.brand.logo,
                };
              });
          }
          // Check if is available points of sale data upgrade
          let fieldsToUpdate: TDataUpgrade[] = [];
          const dataCompared = [
            {
              field: 'online',
              oldValue: pointOfSale.online === true ? 'Online' : 'Tienda Física',
              newValue:
                pointOfSale.point_of_sale?.online === true ? 'Online' : 'Tienda Física',
              values: { online: pointOfSale.point_of_sale?.online },
            },
            {
              field: 'name',
              oldValue: pointOfSale.name,
              newValue: pointOfSale.point_of_sale?.name,
              values: { name: pointOfSale.point_of_sale?.name },
            },
            {
              field: 'area',
              oldValue: pointOfSale.area,
              newValue: pointOfSale.point_of_sale?.area,
              values: { area: pointOfSale.point_of_sale?.area },
            },
            {
              field: 'floor',
              oldValue: pointOfSale.floor,
              newValue: pointOfSale.point_of_sale?.floor,
              values: { floor: pointOfSale.point_of_sale?.floor },
            },
            {
              field: 'door',
              oldValue: pointOfSale.door,
              newValue: pointOfSale.point_of_sale?.door,
              values: { door: pointOfSale.point_of_sale?.door },
            },
            {
              field: 'city',
              oldValue: pointOfSale.city,
              newValue: pointOfSale.point_of_sale?.city,
              values: { city: pointOfSale.point_of_sale?.city },
            },
            {
              field: 'province',
              oldValue: pointOfSale.province,
              newValue: pointOfSale.point_of_sale?.province,
              values: { province: pointOfSale.point_of_sale?.province },
            },
            {
              field: 'postal_code',
              oldValue: pointOfSale.postal_code,
              newValue: pointOfSale.point_of_sale?.postal_code,
              values: { postal_code: pointOfSale.point_of_sale?.postal_code },
            },
            {
              field: 'lat',
              oldValue: pointOfSale.lat,
              newValue: pointOfSale.point_of_sale?.lat,
              values: { lat: pointOfSale.point_of_sale?.lat },
            },
            {
              field: 'lng',
              oldValue: pointOfSale.lng,
              newValue: pointOfSale.point_of_sale?.lng,
              values: { lng: pointOfSale.point_of_sale?.lng },
            },
            {
              field: 'tel_prefix',
              oldValue: pointOfSale.tel_prefix,
              newValue: pointOfSale.point_of_sale?.tel_prefix,
              values: { tel_prefix: pointOfSale.point_of_sale?.tel_prefix },
            },
            {
              field: 'tel_sufix',
              oldValue: pointOfSale.tel_sufix,
              newValue: pointOfSale.point_of_sale?.tel_sufix,
              values: { tel_sufix: pointOfSale.point_of_sale?.tel_sufix },
            },
            {
              field: 'web',
              oldValue: pointOfSale.web,
              newValue: pointOfSale.point_of_sale?.web,
              values: { web: pointOfSale.point_of_sale?.web },
            },
            {
              field: 'exchange_id',
              oldValue:
                exchanges.find((ex) => ex.id === pointOfSale.exchange_id)?.currency ??
                null,
              newValue:
                exchanges.find((ex) => ex.id === pointOfSale.point_of_sale?.exchange_id)
                  ?.currency ?? null,
              values: {
                exchange_id:
                  exchanges.find((ex) => ex.id === pointOfSale.point_of_sale?.exchange_id)
                    ?.id ?? null,
              },
            },
            {
              field: 'address',
              oldValue: pointOfSale.address,
              newValue: pointOfSale.point_of_sale?.address,
              values: {
                address: pointOfSale.point_of_sale?.address,
                lat: pointOfSale.point_of_sale?.lat,
                lng: pointOfSale.point_of_sale?.lng,
              },
            },
            {
              field: 'country_id',
              oldValue: countries.find((country) => country.id === pointOfSale.country_id)
                ?.name
                ? translate(
                    `google-address-form_country_${countries.find((country) => country.id === pointOfSale.country_id)?.name}`
                  )
                : null,
              newValue: countries.find(
                (country) => country.id === pointOfSale.point_of_sale?.country_id
              )?.name
                ? translate(
                    `google-address-form_country_${countries.find((country) => country.id === pointOfSale.point_of_sale?.country_id)?.name}`
                  )
                : null,
              values: {
                country_id:
                  countries.find(
                    (country) => country.id === pointOfSale.point_of_sale?.country_id
                  )?.id ?? null,
              },
            },
          ];
          dataCompared.forEach((item) => {
            if (
              item.newValue !== undefined &&
              item.newValue !== null &&
              item.oldValue !== item.newValue
            ) {
              fieldsToUpdate.push({
                pointOfSaleId: pointOfSale.id,
                field: item.field as TUpgradeFields,
                oldValue: item.oldValue,
                newValue: item.newValue,
                values: item.values as
                  | IPointOfSaleExchangesState
                  | TAddressaValues
                  | ICountryAPIResponseItem
                  | undefined,
              });
            }
          });
          if (
            getStateName({
              stateId: pointOfSale.state_id,
              associationStates,
            }) === status.connected
          ) {
            pointOfSaleObj.fieldsToUpdate = fieldsToUpdate;
          }
          pointsOfSale.push(pointOfSaleObj);
        }
      }
    }
  } else {
    const getClientPointsOfSaleFecth = await api.getClientPointsOfSaleAPI(id, token);
    if (getClientPointsOfSaleFecth.response.status === 200) {
      const sortPointsOfSale = getClientPointsOfSaleFecth?.data?.point_of_sales.sort(
        (a, b) => a.name.localeCompare(b.name)
      );
      for (const [index, pointOfSale] of sortPointsOfSale
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .entries()) {
        const {
          id,
          name,
          contact_name,
          address,
          city,
          area,
          country_id,
          postal_code,
          province,
          door,
          floor,
          lat,
          lng,
          full_price,
          online,
          web,
          tel_prefix,
          tel_sufix,
          point_of_sale_categories,
          createdAt,
          updatedAt,
          exchange_id,
        } = pointOfSale;
        const pointOfSaleObj: IPointOfSaleState = {
          index: index,
          key: id,
          code: '',
          name: name,
          businessName: '',
          tradeName: '',
          client_alias_id: client_alias_id,
          point_of_sale_id: id,
          area: area ?? 0,
          country: {
            id: country_id as string,
            name: countries.find((country) => country.id === country_id)?.name as string,
          },
          state_id: '',
          state_name: '',
          categories: point_of_sale_categories.map(
            (item) => item.point_of_sale_category.id
          ),
          province: province,
          city: city,
          postal_code: postal_code,
          address: address,
          door: door as string,
          floor: floor as string,
          lat: lat,
          lng: lng,
          tel_prefix: tel_prefix,
          tel_sufix: tel_sufix,
          start_season: '',
          start_date: '',
          web: web as string,
          email: email,
          full_price: full_price,
          online: online,
          connected: false,
          receiving: false,
          data_share: false,
          contact_name: contact_name as string,
          point_of_sale_brand_works: pointOfSale.point_of_sale_brand_works.map((ps) => ({
            id: ps.brand_id,
            name: ps.brand.name,
            logo: ps.brand.logo,
          })),
          clientStatus: '',
          exchange_id: exchange_id,
          division_id: [],
          segmentation_id: [],
          tier_id: [],
          createdAt: createdAt,
          updatedAt: updatedAt,
          last_sale: null,
          hss: 0,
          own_store: false,
        };
        pointsOfSale.push(pointOfSaleObj);
      }
    }
  }

  let clientDataToUpgradeItems: TclientDataToUpgradeItem[] = [];
  let clientTarif: Array<ITarifClientsItem> = [];

  try {
    const getClientFetch = await api.getClientProfileAPI(client_id, token);
    if (getClientFetch.response.status === 200) {
      clientTarif = getClientFetch.data.tarif_clients ?? [];
      const clientCurrentData: Partial<IClientState> = {
        name: getClientFetch.data.name,
        legal_name: getClientFetch.data.legal_name,
        cif: getClientFetch.data.cif,
        web: getClientFetch.data.web,
        address: getClientFetch.data.address,
        floor: getClientFetch.data.floor,
        door: getClientFetch.data.door,
        lat: getClientFetch.data.lat,
        lng: getClientFetch.data.lng,
        postal_code: getClientFetch.data.postal_code,
        city: getClientFetch.data.city,
        province: getClientFetch.data.province,
        country_id: getClientFetch.data.country?.id,
        contact_name: getClientFetch.data.contact_name ?? '',
        email: getClientFetch.data.email,
        tel_prefix: getClientFetch.data.telephone_prefix,
        tel_sufix: getClientFetch.data.telephone_sufix,
        instagram: getClientFetch.data.instagram ?? '',
        youtube: getClientFetch.data.youtube ?? '',
        facebook: getClientFetch.data.facebook ?? '',
        linkedin: getClientFetch.data.linkedin ?? '',
      };

      const clientOwnData: Partial<IClientState> = {
        name,
        legal_name,
        cif,
        web,
        address,
        floor,
        door,
        lat,
        lng,
        postal_code,
        city,
        province,
        country_id: clientCountryId,
        contact_name,
        email,
        tel_prefix,
        tel_sufix,
        instagram,
        youtube,
        facebook,
        linkedin,
      };

      clientDataToUpgradeItems = Object.entries(clientCurrentData)
        .map(([key, value]) => {
          if (
            value === clientOwnData[key as keyof IClientState] ||
            ((value === '' || value === null) && key !== 'floor' && key !== 'door')
          )
            return null;
          return {
            key,
            newValue: value,
            oldValue: clientOwnData[key as keyof IClientState],
          };
        })
        .filter((item) => item !== null) as TclientDataToUpgradeItem[];

      const haveToUpgradeAddress = clientDataToUpgradeItems.find(
        (item) => item.key === 'address'
      );

      if (haveToUpgradeAddress) {
        clientDataToUpgradeItems.push({
          key: 'lat',
          newValue: getClientFetch.data.lat,
          oldValue: lat,
        });
        clientDataToUpgradeItems.push({
          key: 'lng',
          newValue: getClientFetch.data.lng,
          oldValue: lng,
        });
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    const getClient: IClientState = {
      key: id,
      code: code,
      name,
      legal_name,
      cif: cif,
      address: address,
      postal_code: postal_code,
      city: city,
      country_id: clientCountryId,
      province: province,
      floor: floor,
      door: door,
      lat: lat,
      lng: lng,
      email: email,
      web: web,
      createdAt,
      updatedAt,
      tel_prefix: tel_prefix,
      tel_sufix: tel_sufix,
      contact_name: contact_name,
      status: statusType,
      totalPointsSale: pointsOfSale.length,
      segmentations: `${segmentations.length > 0 ? segmentations.join(', ') : ''}`,
      tiers: `${tiers.length > 0 ? 'Tiers: ' + tiers.join(', ') : ''}`,
      clientSalePoint: pointsOfSale
        .sort((a, b) => a.state_name?.localeCompare(b.state_name))
        .map((pointOfSale, index) => {
          return {
            ...pointOfSale,
            index: index,
          };
        }),
      associationInfo: {
        id: clientId,
        client_id: client_id,
        client_alias_id: client_alias_id,
        state_id: state_id,
        state_name: getStateName({ stateId: state_id, associationStates }) as string,
        brand_id: brand_id,
        client_ok: client_ok,
        brand_ok: brand_ok,
        createdAt: createdAt,
        updatedAt: updatedAt,
      },
      clientStatus: '',
      clientBrandsSold: [],
      enableModify: false,
      contacts: [],
      pendingPointsOfSaleAssociations: 0,
      matching: null,
      instagram,
      youtube,
      facebook,
      linkedin,
      clientDataToUpgrade: clientDataToUpgradeItems,
      tarif_clients: clientTarif,
    };
    return getClient;
  }
}

const getStateName = ({
  stateId,
  associationStates,
}: {
  stateId: string;
  associationStates: IAssociationsStates;
}) => {
  if (stateId === associationStates.pending.id) {
    return associationStates.pending.state;
  }
  if (stateId === associationStates.connected.id) {
    return associationStates.connected.state;
  }
  if (stateId === associationStates.rejected.id) {
    return associationStates.rejected.state;
  }
  if (stateId === associationStates.disconnected.id) {
    return associationStates.disconnected.state;
  }
};
